export default {"src":"/_next/static/media/LINK_BROKEN.23f31b98.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};